import { render, staticRenderFns } from "./itemXero.vue?vue&type=template&id=77b5f2ae&scoped=true&"
import script from "./itemXero.vue?vue&type=script&lang=js&"
export * from "./itemXero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b5f2ae",
  null
  
)

export default component.exports